import Vue from 'vue';
import VueHtml2pdf from 'vue-html2pdf';
import Fragment from 'vue-fragment';
import VueSocialSharing from 'vue-social-sharing';
import { validationMixin } from 'vuelidate';
import router from './router';
import store from './store';
import App from './vue/App.vue';

Vue.component('App', require('./vue/App.vue').default);

Vue.use(VueHtml2pdf);
Vue.use(Fragment.Plugin);
Vue.use(VueSocialSharing);
Vue.mixin(validationMixin);

export default () => {

  // console.log(router);

  const app = new Vue({
    el: '#app',
    store,
    router,
    template: '<App/>',
    components: { App },
  });
};
